// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const APISignetIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="APISignetIcon" ref={forwardedRef} {...props}>
      <path d="M16.5 5.48v4.47a1.24 1.24 0 0 1-.611 1.074l-3.955 2.314a.318.318 0 0 1-.476-.28v-1.835a1.28 1.28 0 0 0-1.271-1.288H6.415V5.462a1.21 1.21 0 0 1 .597-1.046l3.85-2.254a1.18 1.18 0 0 1 1.192 0l3.835 2.244A1.24 1.24 0 0 1 16.5 5.48" />
      <path d="M11.458 15.046v.584c0 1.308-1.047 2.37-2.339 2.37H5.84c-1.293 0-2.34-1.061-2.34-2.37v-3.325c0-1.309 1.047-2.37 2.338-2.37h.577v.063c.034 2.793 2.279 5.048 5.043 5.048" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const APISignetIcon = /* @__PURE__ */ Object.assign(
  APISignetIconComponent,
  { displayName: 'APISignetIcon' },
);
